<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="用户ID" prop="id">
                <a-input v-model="queryParam.id" placeholder="请输入用户ID" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="邮箱" prop="email">
                <a-input v-model="queryParam.email" placeholder="请输入邮箱" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="手机号" prop="mobile">
                <a-input v-model="queryParam.mobile" placeholder="请输入手机号" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="昵称" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入昵称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="性别" prop="sex">
                <a-select placeholder="请选择性别" v-model="queryParam.sex" style="width: 100%" allow-clear>
                  <a-select-option :key="0" >保密</a-select-option>
                  <a-select-option :key="1" >男</a-select-option>
                  <a-select-option :key="2" >女</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="用户状态" prop="status">
                <a-select placeholder="请选择用户状态" v-model="queryParam.status" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in dict.type.sys_enable_disable" :key="index" :value="d.value">{{ d.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="是否分销" prop="referralEnabled">
                <a-select placeholder="请选择是否分销" v-model="queryParam.referralEnabled" style="width: 100%" allow-clear>
                  <a-select-option :value="1">是</a-select-option>
                  <a-select-option :value="0">否</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="是否拉黑" prop="isBlacklisted">
                <a-select placeholder="请选择是否拉黑" v-model="queryParam.isBlacklisted" style="width: 100%" allow-clear>
                  <a-select-option :value="1">是</a-select-option>
                  <a-select-option :value="0">否</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="未提现用户" prop="hasUnwithdrawnBalance">
                <a-select placeholder="请选择" v-model="queryParam.hasUnwithdrawnBalance" style="width: 100%" allow-clear>
                  <a-select-option :value="1">有余额未提现</a-select-option>
                  <a-select-option :value="0">无余额</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
<!--            <template v-if="advanced">-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="邀请码" prop="invitationCode">-->
<!--                  <a-input v-model="queryParam.invitationCode" placeholder="请输入邀请码" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="是否推送" prop="isNotice">-->
<!--                  <a-select placeholder="请选择是否推送" v-model="queryParam.isNotice" style="width: 100%" allow-clear>-->
<!--                    <a-select-option v-for="(d, index) in dict.type.sys_notice_status" :key="index" :value="d.value">{{ d.label }}</a-select-option>-->
<!--                  </a-select>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--            </template>-->
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">


        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" style="margin-bottom: 20px;" />
      </div>
      <!-- 增加修改 -->
      <reset-password ref="resetPassword" />
      <bank-card-manage ref="bankCardManage" />
      <user-detail ref="userDetail" />
      <edit-amounts ref="editAmounts" @ok="getList" />
      <amount-modify-logs ref="amountModifyLogs" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :scroll="{x:true}"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        @change="handleTableChange"
      >
        <span slot="sex" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_user_sex']" :value="record.sex"/>
        </span>
        <span slot="avatar" slot-scope="text, record">
          <oss-img
            v-if="text && !brokenAvatars[record.id]"
            :src="text"
            class="user-avatar"
            @error="onAvatarError(record.id)"
          />
          <a-avatar v-else icon="user" :size="40" />
        </span>
        <span slot="csAgent" slot-scope="text, record">
          <template v-if="record.csBound === 1 && (record.csAgentName || record.csAgentId)">
            {{ record.csAgentName || record.csAgentId }}
          </template>
          <span v-else style="color: #999">未绑定</span>
        </span>

<!--        <span slot="status" slot-scope="text, record">-->
<!--          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status"/>-->
<!--        </span>-->

<!--        <span slot="status" slot-scope="text, record">-->
          <a-switch slot="status" slot-scope="text, record" v-model="record.status" @change="onChange($event,record)" />
<!--          <a-switch v-lacksPermi="['biz:user:status']" v-model="record.status" :disabled="true" />-->
<!--        </span>-->
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="referralEnabled" slot-scope="text, record">
          <a-tag :color="record.referralEnabled === 0 ? 'red' : 'green'">
            {{ record.referralEnabled === 0 ? '否' : '是' }}
          </a-tag>
        </span>
        <span slot="isBlacklisted" slot-scope="text, record">
          <a-tag :color="record.isBlacklisted === 1 ? 'red' : 'green'">
            {{ record.isBlacklisted === 1 ? '已拉黑' : '正常' }}
          </a-tag>
        </span>
        <span slot="userTotalAmount" slot-scope="text">
          <span class="amount-cell total">{{ formatMoney(text) }}</span>
        </span>
        <span slot="money" slot-scope="text">
          <span class="amount-cell wallet">{{ formatMoney(text) }}</span>
        </span>
        <span slot="totalWithdrawnAmount" slot-scope="text">
          <span class="amount-cell earnings">{{ formatMoney(text) }}</span>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.userDetail.handleOpen(record)">
            <a-icon type="eye" />详情
          </a>
          <a-divider type="vertical" />
          <a-dropdown :trigger="['click']">
            <a class="ant-dropdown-link" @click.prevent>
              更多 <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item key="editAmount" @click="$refs.editAmounts.handleOpen(record)">
                <a-icon type="edit" />编辑金额
              </a-menu-item>
              <a-menu-item key="amountLogs" @click="$refs.amountModifyLogs.handleOpen(record)">
                <a-icon type="profile" />金额修改记录
              </a-menu-item>
              <a-menu-item key="cs" @click="handleOpenCsChat(record)">
                <a-icon type="message" />发起会话
              </a-menu-item>
              <a-menu-item key="pwd" @click="$refs.resetPassword.handleResetPwd(record)">
                <a-icon type="edit" />重置密码
              </a-menu-item>
              <a-menu-item key="bank" @click="$refs.bankCardManage.handleOpen(record)">
                <a-icon type="bank" />银行卡管理
              </a-menu-item>
              <a-menu-item key="referral" @click="handleToggleReferral(record)">
                <a-icon type="team" />{{ record.referralEnabled === 0 ? '开启分销' : '关闭分销' }}
              </a-menu-item>
              <a-menu-item key="blacklist" @click="handleToggleBlacklist(record)">
                <a-icon type="stop" />
                <span :style="{ color: record.isBlacklisted === 1 ? '#52c41a' : '#f5222d' }">
                  {{ record.isBlacklisted === 1 ? '解除拉黑' : '拉黑' }}
                </span>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageUser,listUser, delUser, updateUser, updateReferralEnabled, updateBlacklist } from '@/api/biz/user'
import { tableMixin } from '@/store/table-mixin'
import { navigateToCsWorkbench } from '@/utils/csEmbed'
import ResetPassword from './modules/ResetPassword'
import BankCardManage from './modules/BankCardManage'
import UserDetail from './modules/UserDetail'
import EditAmounts from './modules/EditAmounts'
import AmountModifyLogs from './modules/AmountModifyLogs'
export default {
  name: 'User',
  components: {
    ResetPassword,
    BankCardManage,
    UserDetail,
    EditAmounts,
    AmountModifyLogs
  },
  mixins: [tableMixin],
  dicts: ['sys_user_sex', 'sys_enable_disable'],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 头像加载失败的用户 id，回退默认头像
      brokenAvatars: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: '',
        email: null,
        mobile: null,
        nickname: null,
        sex: undefined,
        invitationCode: null,
        isNotice: null,
        status: undefined,
        referralEnabled: undefined,
        isBlacklisted: undefined,
        hasUnwithdrawnBalance: undefined,
        sortField: undefined,
        sortOrder: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          align: 'center'
        },
        {
          title: '头像',
          dataIndex: 'avatar',
          align: 'center',
          width: 72,
          scopedSlots: { customRender: 'avatar' }
        },
        {
          title: '邮箱',
          dataIndex: 'email',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '手机号',
          dataIndex: 'mobile',
          width: 130,
          align: 'center',
          customRender(t) {
            return t || '—'
          }
        },
        {
          title: '昵称',
          dataIndex: 'nickname',
          align: 'center'
        },
        {
          title: '客服',
          dataIndex: 'csAgentName',
          align: 'center',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'csAgent' }
        },
        {
          title: '性别',
          dataIndex: 'sex',
          align: 'center',
          width: 80,
          customRender(t,r) {
            if(r.sex == 0) {
              return '保密';
            } else if(r.sex == 1) {
              return '男';
            } else if(r.sex == 2) {
              return '女';
            }
          }
        },
        {
          title: '历史交易总额',
          dataIndex: 'userTotalAmount',
          width: 140,
          align: 'right',
          sorter: true,
          scopedSlots: { customRender: 'userTotalAmount' }
        },
        {
          title: '钱包未提现余额',
          dataIndex: 'money',
          width: 150,
          align: 'right',
          sorter: true,
          scopedSlots: { customRender: 'money' }
        },
        {
          title: '用户已提现总额',
          dataIndex: 'totalWithdrawnAmount',
          width: 150,
          align: 'right',
          sorter: true,
          scopedSlots: { customRender: 'totalWithdrawnAmount' }
        },
        {
          title: '用户状态',
          dataIndex: 'status',
          width: 100,
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: '是否分销',
          dataIndex: 'referralEnabled',
          width: 100,
          scopedSlots: { customRender: 'referralEnabled' },
          align: 'center'
        },
        {
          title: '拉黑状态',
          dataIndex: 'isBlacklisted',
          width: 100,
          scopedSlots: { customRender: 'isBlacklisted' },
          align: 'center'
        },
        {
          title: '注册时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 140,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    formatMoney(val) {
      if (val == null || val === '') return '—'
      const num = Number(val)
      if (Number.isNaN(num)) return val
      return num.toFixed(2)
    },
    onAvatarError(userId) {
      if (userId == null) return
      this.$set(this.brokenAvatars, userId, true)
    },
    openXinde(record) {
      this.$refs.cityArticleForm.show({
        userId:record.id,
        id: null,
        type:1
      })
    },
    onChange(e,record) {
      let recordData =JSON.parse(JSON.stringify(record));
      recordData.status = e ? 1 : 0;
      this.updateData(recordData);
      record.status = e ? 1 : 0;
    },
    updateData(record) {
      updateUser(record).then(res => {
        if (this.isApiSuccess(res)) {
          this.$message.success('操作成功')
          this.getList()
        } else {
          this.$message.error(res.message || '操作失败')
        }
      })
    },
    isApiSuccess(res) {
      return res && (res.code == 20001 || res.code === '20001')
    },
    buildPageQuery () {
      const params = { ...this.queryParam }
      const id = params.id != null ? String(params.id).trim() : ''
      if (id) {
        params.id = id
      } else {
        delete params.id
      }
      return params
    },
    /** 查询用户信息列表 */
    getList () {
      this.loading = true
      pageUser(this.buildPageQuery()).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleTableChange (pagination, filters, sorter) {
      if (sorter && sorter.order) {
        this.queryParam.sortField = sorter.field
        this.queryParam.sortOrder = sorter.order === 'descend' ? 'DESCEND' : 'ASCEND'
      } else {
        this.queryParam.sortField = undefined
        this.queryParam.sortOrder = undefined
      }
      this.getList()
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        id: '',
        email: undefined,
        mobile: undefined,
        nickname: undefined,
        sex: undefined,
        invitationCode: undefined,
        isNotice: undefined,
        status: undefined,
        referralEnabled: undefined,
        isBlacklisted: undefined,
        hasUnwithdrawnBalance: undefined,
        sortField: undefined,
        sortOrder: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    /** 跳转在线客服工作台，对该用户发起主动会话 */
    handleOpenCsChat (record) {
      if (!record || record.id == null) {
        this.$message.warning('无法获取用户 ID')
        return
      }
      navigateToCsWorkbench(this.$router, this.$store, {
        customerId: record.id,
        name: record.nickname || record.email || String(record.id),
        avatar: record.avatar || '',
        autoAccept: true
      })
    },
    handleToggleBlacklist (record) {
      const nextBlacklisted = record.isBlacklisted === 1 ? 0 : 1
      const actionText = nextBlacklisted === 1 ? '拉黑' : '解除拉黑'
      const that = this
      this.$confirm({
        title: '确认操作',
        content: nextBlacklisted === 1
          ? `确定要拉黑用户「${record.nickname || record.email || record.id}」吗？拉黑后该用户将无法登录及访问 App。`
          : `确定要解除用户「${record.nickname || record.email || record.id}」的拉黑吗？`,
        onOk () {
          return updateBlacklist({ id: record.id, isBlacklisted: nextBlacklisted }).then(res => {
            if (that.isApiSuccess(res)) {
              that.$message.success(`${actionText}成功`)
              that.getList()
            } else {
              that.$message.error(res.message || '操作失败')
            }
          })
        }
      })
    },
    handleToggleReferral (record) {
      const nextEnabled = record.referralEnabled === 0 ? 1 : 0
      const actionText = nextEnabled === 1 ? '开启' : '关闭'
      const that = this
      this.$confirm({
        title: '确认操作',
        content: `确定要${actionText}用户「${record.nickname || record.email || record.id}」的分销佣金吗？${nextEnabled === 0 ? '关闭后其直接邀请的用户成交时将不再获得佣金（不含二级下级）。' : ''}`,
        onOk () {
          return updateReferralEnabled({ id: record.id, referralEnabled: nextEnabled }).then(res => {
            if (that.isApiSuccess(res)) {
              that.$message.success(`${actionText}分销成功`)
              that.getList()
            } else {
              that.$message.error(res.message || '操作失败')
            }
          })
        }
      })
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delUser(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('biz/user/export', {
            ...that.buildPageQuery()
          }, `用户信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style scoped>
.amount-cell {
  display: inline-block;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.amount-cell.total {
  color: #722ed1;
  font-size: 15px;
}
.amount-cell.wallet {
  color: #1890ff;
  font-size: 15px;
}
.amount-cell.earnings {
  color: #52c41a;
  font-size: 15px;
}
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  display: inline-block;
  vertical-align: middle;
}
</style>
